import React, {useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";

const CarteVitalePhase = () => {
    const [numCarteVitale, setNumCarteVitale] = useState("")
    const [loading, setLoading] = useState(false)

    const cleanedNum = numCarteVitale.replace(/\s/g, "").toUpperCase()
    const isValid = !!Helper.checkSsn(cleanedNum) && Helper.checkSsnKey(cleanedNum)
    const showError = cleanedNum.length >= 15 && !isValid

    const submit = () => {
        if (!isValid || loading) return
        setLoading(true)
        axios.post("/patient_login_carte_vitale", {num_carte_vitale: cleanedNum})
            .then((res) => {
                window.location.href = res.data.redirect_url
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || "Une erreur est survenue")
                setLoading(false)
            })
    }

    return (
        <div>
            <h5>
                Pour accéder à vos prescriptions, merci de renseigner votre numéro de carte Vitale :
            </h5>
            <div style={{display: "flex", flexDirection: "column", gap: 20}}>
                <div className="row">
                    <div className="col s12 l6 offset-l3">
                        <p>Numéro de carte Vitale (15 caractères, clé incluse)</p>
                        <div className="input-field">
                            <input type="text" value={numCarteVitale} maxLength={21}
                                   onChange={(e) => setNumCarteVitale(e.target.value)}
                                   onKeyDown={(e) => e.key === "Enter" && submit()}
                            />
                        </div>
                        <p className="grey-text text-darken-1" style={{fontStyle: "italic", marginTop: 0}}>
                            Pour un enfant mineur, saisissez le numéro inscrit sur la carte Vitale utilisée lors de
                            l'examen (souvent celle du parent)
                        </p>
                        {showError ? <p className="red-text">Le numéro de carte Vitale est invalide</p> : null}
                    </div>
                </div>
                <div className="center">
                    <a disabled={!isValid || loading} className="btn blue darken-2 center z-depth-0" onClick={submit}>
                        Valider
                    </a>
                </div>
            </div>
        </div>
    )
}

export default CarteVitalePhase
